import React, {Component, PropTypes} from "react";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {IS_IN_MOBILE_MODE, RESOURCE_BASE_URL} from "../../../../configuration";
import html2canvas from "html2canvas";
import * as jsPDF from "jspdf";
import {FormattedMessage} from "react-intl";
import parse from "html-react-parser";
import "./CartPrint.css";
import {$} from "glamor";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import PriceLoadingImage from "../../../../assets/img/loading_price.gif";

class CartPrint extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            evaluatedTemplate: '',
            pdfFile: '',
            itemData: [],
            language: localStorage.getItem("setLang"),
            pdfData: '',
            generating: false,
            showMobileQuotationModal: false,
            showMobileQuotationModalError: false
        };
        this.getPebbleTemplate = this.getPebbleTemplate.bind(this);
        this.printDocument = this.printDocument.bind(this);
        this.downloadDocument = this.downloadDocument.bind(this);
        this.getLanguageLocale = this.getLanguageLocale.bind(this);
        this.downloadMobileDocument = this.downloadMobileDocument.bind(this);
        this.getPebbleTemplateForMobile = this.getPebbleTemplateForMobile.bind(this);
        this.handleCloseMobileQuotationModal = this.handleCloseMobileQuotationModal.bind(this);
        this.handleCloseMobileQuotationModalError = this.handleCloseMobileQuotationModalError.bind(this);
        // this.printTest = this.printTest.bind(this);
        // this.b64EncodeUnicode = this.b64EncodeUnicode.bind(this);
        // this.b64DecodeUnicode = this.b64DecodeUnicode.bind(this);
    }

    handleClose = () => {
        this.setState({show: false});
    };
    handleCloseMobileQuotationModal = () => {
        this.setState({showMobileQuotationModal: false});
    };
    handleCloseMobileQuotationModalError = () => {
        this.setState({showMobileQuotationModalError: false});
    };

    handleShow = () => {
        this.setState({
            show: true,
            language: localStorage.getItem("setLang")
        });
        this.getPebbleTemplate();
        this.getLanguageLocale();

    };

    componentDidMount() {
        this.getLanguageLocale();
        // this.getPebbleTemplate();
    }

    getLanguageLocale = () => {
        localStorage.getItem("setLang");
        this.setState({
            language: localStorage.getItem("setLang")
        });
    };

    getPebbleTemplate = () => {
        if (this.state.evaluatedTemplate === '') {
            this.setState({
                generating: true
            });
        }
        axios.get(RESOURCE_BASE_URL + 'api/cart/' + this.props.userId + '/' + this.props.itemDetails.id + '/quotation/' + InitialQuotationState.lang)
            .then((res) => {


                this.setState({
                    evaluatedTemplate: res.data.evaluatedTemplate,
                    pdfData: res.data.pdfData,
                    generating: false
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({
                    generating: false
                })
            });
    };
    getPebbleTemplateForMobile = () => {
        this.setState({
            generating: true,
            showMobileQuotationModal: true
        });
        axios.get(RESOURCE_BASE_URL + 'api/cart/' + this.props.userId + '/' + this.props.itemDetails.id + '/quotation/' + InitialQuotationState.lang)
            .then((res) => {


                this.setState({
                    evaluatedTemplate: res.data.evaluatedTemplate,
                    pdfData: res.data.pdfData,
                    generating: false,
                    showMobileQuotationModal: false
                }, () => this.downloadMobileDocument());
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({
                    generating: false,
                    showMobileQuotationModal: false,
                    showMobileQuotationModalError: true
                })
            });
    };

    downloadDocument() {
        fetch("data:application/pdf;base64," + this.state.pdfData)
            .then((resp) => {
                return resp.blob()
            })

            .then((blob) => {

                const fileURL = URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;

                let today = new Date();
                let date = today.getFullYear().toString() + (today.getMonth() + 1).toString().padStart(2, "0") + today.getDate().toString().padStart(2, "0");
                let time = today.getHours().toString().padStart(2, "0") + today.getMinutes().toString().padStart(2, "0") + today.getSeconds().toString().padStart(2, "0");

                fileLink.download = date + time;
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);
            });
    }

    downloadMobileDocument = () => {
        fetch("data:application/pdf;base64," + this.state.pdfData)
            .then((resp) => {
                return resp.blob()
            })

            .then((blob) => {

                const fileURL = URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;

                let today = new Date();
                let date = today.getFullYear().toString() + (today.getMonth() + 1).toString().padStart(2, "0") + today.getDate().toString().padStart(2, "0");
                let time = today.getHours().toString().padStart(2, "0") + today.getMinutes().toString().padStart(2, "0") + today.getSeconds().toString().padStart(2, "0");

                fileLink.download = date + time;
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);
            });
    };

    printDocument() {
        fetch("data:application/pdf;base64," + this.state.pdfData)
            .then((resp) => {
                return resp.blob()
            })

            .then((blob) => {

                const fileURL = URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                window.open(fileURL, "_blank").print();
            });
    }

    render() {
        return (
            <span>
            <a hidden={IS_IN_MOBILE_MODE} className=" cart-change-font-mobile print-text cart-row-text-color" onClick={this.handleShow}>
            {/*<FormattedMessage id="app.print-quotation.print"*/}
                {/*defaultMessage="Print"*/}
                {/*description=""/>*/}
                見積書
            </a>
                <a className=" cart-change-font-mobile print-text cart-row-text-color" hidden={!IS_IN_MOBILE_MODE}
                   onClick={this.getPebbleTemplateForMobile}>
                見積書
                </a>
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <div className="title-1 color-text">
                    {/*<FormattedMessage id="app.print-quotation.title"
                                      defaultMessage="Quotation Data"
                                      description=""/> :&nbsp;&nbsp; <FormattedMessage id="app.print-quotation.title-no"
                                                                                       defaultMessage="Item"
                                                                                       description=""/> #
                    {this.props.itemDetails.id}*/}
                </div>
            </Modal.Header>
            <Modal.Body>
                {this.state.generating === true ?
                    <div className="text-center">
                        {/*<img className="generating-invoice" src={PriceLoadingImage} alt="見積の生成。お待ちください..."/><br/><br/>*/}
                        <img className="generating-invoice" src={PriceLoadingImage} alt="少し、お待ち下さい。"/><br/><br/>
                        {/*<h4>見積の生成。お待ちください...</h4>*/}
                        <h4>少し、お待ち下さい。</h4>
                    </div> : ""
                }
                <div id="print-div" className="print-div" ref={r => this.quotationTemplate = r}>
                        {parse(this.state.evaluatedTemplate)}
                    </div>

            </Modal.Body>
            <Modal.Footer>
                {this.state.evaluatedTemplate !== '' ?
                    <div className="print-cart-item-div">
                        <button className="btn download-btn-quot" onClick={this.downloadDocument}>
                            <FormattedMessage id="app.print-quotation.download"
                                              defaultMessage="Download"
                                              description=""/>
                        </button>
                        <button className="btn print-btn-quot" onClick={this.printDocument}>
                            <FormattedMessage id="app.print-quotation.print"
                                              defaultMessage="Print"
                                              description=""/>
                        </button>

                    </div> : ""
                }

            </Modal.Footer>
        </Modal>

                {/*==================================== mobile processing modal ==============================*/}

                <Modal show={this.state.showMobileQuotationModal} onHide={this.handleCloseMobileQuotationModal}
                       dialogClassName="modal-90w-mobile-quotation">
            <Modal.Header closeButton>

            </Modal.Header>
            <Modal.Body>
                 <div className="text-center">
                        <img className="generating-invoice" src={PriceLoadingImage} alt="少し、お待ち下さい。"/><br/><br/>
                        <h5>見積書をデバイスに保存中。</h5>
                    </div>

            </Modal.Body>
            <Modal.Footer>


            </Modal.Footer>
        </Modal>


                {/*==================================== mobile processing modal error ==============================*/}

                <Modal show={this.state.showMobileQuotationModalError}
                       onHide={this.handleCloseMobileQuotationModalError} dialogClassName="modal-90w-mobile-quotation">
            <Modal.Header closeButton>

            </Modal.Header>
            <Modal.Body>
                 <div className="text-center">
                        <h4>見積は現在生成できません。後でもう一度やり直してください。</h4>
                    </div>

            </Modal.Body>
            <Modal.Footer>
                <button className="pull-right btn btn-primary"
                        onClick={this.handleCloseMobileQuotationModalError}>閉じる</button>

            </Modal.Footer>
        </Modal>
        </span>
        )
    }

}

export default CartPrint;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartPrint/CartPrint.js